import { createClient } from '@supabase/supabase-js';

const supabaseUrl = (import.meta.env.VITE_SUPABASE_URL || '').trim().replace(/\/$/, '');
const supabaseAnonKey = (import.meta.env.VITE_SUPABASE_ANON_KEY || '').trim();
const supabaseRealtimeUrl = (import.meta.env.VITE_SUPABASE_REALTIME_URL || '').trim();

// Previeni il crash se le variabili sono mancanti
if (!supabaseUrl || !supabaseAnonKey) {
  console.error("ERRORE CRITICO: VITE_SUPABASE_URL o VITE_SUPABASE_ANON_KEY mancanti nei Secrets.");
}

export const supabase = createClient(
  supabaseUrl || 'https://placeholder.supabase.co', 
  supabaseAnonKey || 'placeholder-key',
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      storageKey: 'gev-bologna-auth'
    },
    db: {
      schema: 'public'
    },
    global: {
      headers: { 
        'x-application-name': 'gev-bologna-app',
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache'
      },
    },
    realtime: {
      ...(supabaseRealtimeUrl ? { url: supabaseRealtimeUrl } : {}),
      params: {
        eventsPerSecond: 10
      },
      // Heartbeat ogni 20 secondi per mantenere viva la connessione TCP
      heartbeatIntervalMs: 20000,
      // Timeout più lungo per la connessione iniziale
      timeout: 30000,
    }
  }
);
